import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-cancel-refund-success',
  templateUrl: './cancel-refund-success.component.html',
  styleUrls: ['./cancel-refund-success.component.css']
})
export class CancelRefundSuccessComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<CancelRefundSuccessComponent>,
    public commonService: CommonService
  ) {
  }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
    this.commonService.triggerGridRefresh();
  }

  onClick() {
    this.dialogRef.close();
    this.commonService.triggerGridRefresh();
  }
}
